import {Debugger} from "debug";
import {IController, IModule} from "angular";
import _ from "lodash";
import {KortISamling, KortsamlingKontroller} from "./kortsamling";

const debug: Debugger = require('debug')('KortKontroller');

export class KortKontroller implements IController, KortISamling {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmKort', {
                bindings: {},
                controller: KortKontroller.forInjisering(),
                template: '<div class="kort" ng-class="{\'valgt-kort\':$ctrl.harFokus(), \'annet-kort-valgt\':$ctrl.annetKortHarFokus()}" ng-click="$ctrl.toggleFokus()"><div ng-transclude></div></div>',
                transclude: true,
                require: {kortsamling: '^wmKortsamling'}
            });
    }

    static forInjisering() {
        return [KortKontroller];
    }

    kortsamling: KortsamlingKontroller; //settes via require
    private _kallVedFokusMistet: Function[] = [];

    constructor() {
    }

    vedFokusMistet(kall: () => void): KortISamling {
        this._kallVedFokusMistet.push(kall);
        return this;
    }

    kallVedFokusMistet() {
        _(this._kallVedFokusMistet).each(k => {
            k();
        });
    }

    fokuser() {
        this.kortsamling.fokuser(this);
    }

    slippFokus() {
        this.kortsamling.slippFokus();
    }

    harFokus() {
        return this.kortsamling.kortMedFokus == this;
    }

    annetKortHarFokus() {
        return this.kortsamling.kortMedFokus != null &&
            this.kortsamling.kortMedFokus != this;
    }

    toggleFokus() {
        if (this.harFokus()) this.slippFokus()
        else this.fokuser();
    }

    $onInit(): void {
        this.kortsamling.registrer(this);
    }

}